/**
 * PLEASE do not use Mixins anymore,
 * If you are going to add a new method in this mixin consider UPGRADE THIS CODE to a high order component
 *
 */
const ModulesMixinsOutsideClick = {
    _composite: function (obj) {
        for (var prop in this) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && (prop.charAt(0) !== '_')) {
                obj[prop] = this[prop];
            }
        }
        return obj;
    },
    // This is one of the cases why we need to composite the mixing @ovi
    componentDidMount: function () {
        $(document).bind('click', this._documentClickHandler);
    },
    componentWillUnmount: function () {
        $(document).unbind('click', this._documentClickHandler);
    },
    _documentClickHandler: function (e) {
        var content = ReactDOM.findDOMNode(this.refs.outside_click_content);
        var trigger = ReactDOM.findDOMNode(this.refs.outside_click_trigger);

        if (content && trigger) {
            if (e.target != content && $(content).has(e.target).length === 0
                && e.target != trigger && $(trigger).has(e.target).length === 0) {

                if (this.outsideClickHandle) {
                    this.outsideClickHandle(e);
                }
            }
        }
    }
};